module.exports = __webpack_public_path__ + "img/JC.b9743a69.svg";